import FormComponent from '../FormComponent';
import SelectorEngine from '../../utils/dom/selector-engine';
import EventHandler from '../../utils/dom/event-handler';
import { ClassNames } from '../../utils/dom/css-classes';

const CHANGE_EVENT = 'change';

class CheckboxComponent extends FormComponent {
	constructor(containerElement, config) {
		super(containerElement, config);
		this.classPrefix = 'lta-form-check';
		this.errorMessage = config.data.errorMessage || 'Select at least one option';
		this.data.minSelectable = config.data.minSelectable >=0 ? config.data.minSelectable : 1;
		this.data.maxSelectable = config.data?.maxSelectable;
		(this.minSelectableErrorMessage = config.data.minSelectableErrorMessage || `Minimum ${this.data.minSelectable} options should be selected`),
		(this.maxSelectableErrorMessage = config.data.maxSelectableErrorMessage || `Maximum ${this.data.maxSelectable} options allowed`),
			(this.selectedOptions = config?.data?.value || []);
		if (this.data?.value) {
			this.data.value = this.data?.value?.split(',') || [];
		}
		this.initEventListeners();
		setTimeout(() => {
			this.handleCheckboxClick(false);
		}, 0);
	}

	markup(value, data, titleMarkup) {
		return `
			<fieldset>
				<legend>${titleMarkup}</legend>
				${
					data?.instructionText
						? `<p class="lta-text-input__label u-text-grey-lta lta-heading-subtitle">${data?.instructionText}</p>`
						: ''
				}
				<div class="lta-form-check-group u-mb-5">
					<div id="lta-radio-checkbox-error" class="lta-form-check--error u-mb-1 u-hidden">${data.errorMessage}</div>
					<div class="lta-form-check--options lta-form-checkbox">
						${data.options
							.map(
								(option) => `
							<div class="lta-form-check--option lta-form-lozenge u-mb-1">
								<input class="lta-form-check-input u-mr-2" type="checkbox" id="${data.id}_${option.id}" value="${option.id}" ${
									this.data.value?.includes(option.id) ? 'checked' : ''
								} />
								<label class="lta-form-check-label u-body1" for="${data.id}_${option.id}">${option.label}</label>
							</div>
						`
							)
							.join('')}
					</div>
				</div>
			</fieldset>
		`;
	}

	afterRender() {
		
	}

	initEventListeners() {
		const checkboxes = SelectorEngine.find('input[type="checkbox"]', this.containerEl);

		for (const checkbox of checkboxes) {
			EventHandler.on(checkbox, CHANGE_EVENT, () => {
				this.handleCheckboxClick(true);
			});
		}
	}

	handleCheckboxClick(shouldValidate = true) {
		const checkboxes = SelectorEngine.find('input[type="checkbox"]', this.containerEl);
		this.checkedCheckboxes = checkboxes.filter((checkbox) => checkbox.checked);

		let isValid = true;
		if(shouldValidate) {
			isValid = this.validate();
		}
		if (isValid) this.updateValue(this.checkedCheckboxes);
	}

	validate() {
		const errorElement = SelectorEngine.findOne('#lta-radio-checkbox-error', this.containerEl);
		const inputGroupElement = SelectorEngine.findOne('.lta-form-check-group', this.containerEl);

		const checkboxes = SelectorEngine.find('input[type="checkbox"]', this.containerEl);
		this.checkedCheckboxes = checkboxes.filter((checkbox) => checkbox.checked);

		if (!this.checkedCheckboxes || this.checkedCheckboxes.length < this.data?.minSelectable) {
			if(this.checkedCheckboxes.length === 0) {
				errorElement.innerHTML = this.errorMessage;
			} else {
				errorElement.innerHTML = this.minSelectableErrorMessage;
			}
			errorElement.classList.remove(ClassNames.Hidden);				
			inputGroupElement.classList.add(ClassNames.Invalid, ClassNames.Focused);
			return false;
		} else if (!this.checkedCheckboxes || this.checkedCheckboxes.length > this.data?.maxSelectable) {
			errorElement.classList.remove(ClassNames.Hidden);
			errorElement.innerHTML =  this.maxSelectableErrorMessage
			inputGroupElement.classList.add(ClassNames.Invalid, ClassNames.Focused);
			return false;
		} else {
			errorElement.classList.add(ClassNames.Hidden);
			inputGroupElement.classList.remove(ClassNames.Invalid, ClassNames.Focused);
			return true;
		}
	}

	updateValue(checkedCheckboxes = []) {
		const getSelectedCheckboxData = (selectedCheckbox) => this?.data.options?.find((option) => option.id == selectedCheckbox.value);

		const selectedCheckboxesData = checkedCheckboxes.map((selectedCheckbox) =>
			getSelectedCheckboxData(selectedCheckbox)
		);

		this.value = {
			id: this.data.id,
			fieldName: this.data.fieldName,
			value: selectedCheckboxesData || []
		};

		// NOTE: Currently only supporting one dependent question per checkbox item
		this.dependentQuestion = selectedCheckboxesData.map(({ dependentQuestion }) => dependentQuestion?.[0]);
	}
}

export default CheckboxComponent;
